export class DateUtility {
  private constructor() {
    throw "Should not be called";
  }

  public static middleOfDay(day: Date): Date {
    return new Date(
      Date.UTC(day.getFullYear(), day.getMonth(), day.getDate(), 12, 0)
    );
  }

  public static getTodayMin(): Date {
    const date = new Date();
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0)
    );
  }

  public static getTodayMax(): Date {
    const date = new Date();
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        99,
        999
      )
    );
  }
}
